import { jsx } from "react/jsx-runtime";
import { MainMenuProvider } from "../MainMenu/context/index.js";
import LightMenu from "./LightMenu.js";
const LightMenuWithContext = (mainMenuProps)=>/*#__PURE__*/ jsx(MainMenuProvider, {
        variant: "light",
        ...mainMenuProps,
        children: /*#__PURE__*/ jsx(LightMenu, {})
    });
const LightMenu_LightMenuWithContext = LightMenuWithContext;
export default LightMenu_LightMenuWithContext;
